/*
|--------------------------------------------------------------------------
| App Configuration
|--------------------------------------------------------------------------
|
*/

define('config',[], function () {

    "use strict";

    // Pull data loaded directly into the page
    var configEl = document.getElementById('app-config');
    return configEl ? JSON.parse(configEl.innerHTML) : {};
    
});
